import type { FetchError } from '@execonline-inc/fetch.private';
import type { UseFetch } from '@execonline-inc/react-hooks.private';
import React, { createContext, useContext } from 'react';
import { useFetchResource, useFindLinkByR } from '../Fetch';
import { declareEndpoint, type MissingLinkError } from '../Links';
import * as Resourceable from '../Resourceable';
import { AllExperiencesResource } from './LearningCollections/LearningCollection/CurrentCollectionStep/BuilderV2/Types';

export type DetailsState = UseFetch.State<
  FetchError | MissingLinkError,
  Resourceable.ParsedResponse<'/experience_details', 'get'>
>;

const LearningCollectionDetailsContext = createContext<DetailsState>({ kind: 'loading' });

export const LearningCollectionDetailsProvider: React.FC<{
  resource: AllExperiencesResource;
  children: React.ReactNode;
}> = ({ resource, children }) => {
  const detailsLink = useFindLinkByR({ rel: 'details', method: 'get' }, resource.links);
  const detailsState: DetailsState = useFetchResource(
    detailsLink.map(declareEndpoint('/experience_details')),
  );

  return (
    <LearningCollectionDetailsContext.Provider value={detailsState}>
      {children}
    </LearningCollectionDetailsContext.Provider>
  );
};

export const useLearningCollectionDetails = () => {
  const context = useContext(LearningCollectionDetailsContext);
  if (!context) {
    throw new Error(
      'useLearningCollectionDetails must be used within a LearningCollectionDetailsProvider',
    );
  }
  return context;
};
